function FilterBar({ currentFilter, onFilterChange }) {
  const filters = [
    { id: 'all', label: 'All Plants', icon: '🌿' },
    { id: 'needs-water', label: 'Needs Water', icon: '💧' },
    { id: 'healthy', label: 'Healthy', icon: '✨' }
  ]

  return (
    <section className="filter-section">
      <div className="filter-bar">
        {filters.map(filter => (
          <button
            key={filter.id}
            className={`filter-btn ${currentFilter === filter.id ? "active" : ""}`}
            onClick={() => onFilterChange(filter.id)}
          >
            <span className="filter-icon">{filter.icon}</span>
            <span className="filter-label">{filter.label}</span>
          </button>
        ))}
      </div>
    </section>
  )
}

export default FilterBar